module.exports = __webpack_public_path__ + "img/e9d25cc.svg";